<template>
  <v-app>
    <div class="cube"></div>
    <div class="view">
      <transition name="scroll-y-reverse-transition">
        <router-view />
      </transition>
    </div>
    <div class="bg-2" @mousemove="titleMove" @mouseout="resetMove">
      <div class="navbar">
        <ul>
          <li v-for="(menu, i) in navbars" :key="`_APP-NAVBAR-MENU${i}`">
            <v-tooltip v-if="menu.to.indexOf('http') > -1" bottom>
              <template v-slot:activator="{ on, attrs }">
                <a
                  :href="menu.to"
                  target="_black"
                  v-bind="attrs" v-on="on"
                >{{menu.name.toUpperCase()}}</a>
              </template>
              <span>{{'Jump to ' + menu.to}}</span>
            </v-tooltip>
            <router-link v-else :to="menu.to" tag="a">{{menu.name.toUpperCase()}}</router-link>
          </li>
        </ul>
      </div>
      <span
        class="font-top"
        :style="{transform: `translate(-${coordinate.x}px, calc(-50% - ${coordinate.y}px))`,   transition: moving ? '' : 'ease-in 0.3s'}"
      >Lonay.</span>
      <span
        class="font-bottom"
        :style="{transform: `translate(-${coordinate.x}px, calc(-50% - ${coordinate.y}px))`, letterSpacing: moving ? '18px !important' : '16px',  transition: moving ? 'ease-in 0.16s' : 'ease-in 0.25s'}"
      >Lonay.</span>
      <div class="avatar"></div>
      <div class="footer">
        <span>COPYRIGHT &copy; 2016 - {{new Date().getFullYear()}} Lonay. ALL RIGTHS RESERVED.</span>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      coordinate: { x: 0, y: 0 },
      moving: false,
      navbars: [
        {
          to: "/",
          name: "home"
        },
        {
          to: "https://blog.lonay.me",
          name: "blog"
        },
        {
          to: "/tools",
          name: "tools"
        },
        {
          to: "/pic",
          name: "picture"
        },
        {
          to: "/about",
          name: "about"
        }
      ]
    };
  },
  mounted() {
    // document.addEventListener('mousemove', e => {
    //   let fullWidth = document.documentElement.clientWidth;
    //   let fullHeight = document.documentElement.clientHeight;
    //   let halfWidth = fullWidth / 2;//原屏幕宽的一半（从左至右）
    //   let halfHeight = fullHeight /2;
    //   // console.log({x: (halfWidth - e.clientX)/100, y: (halfHeight - e.clientY)/100})
    //   this.coordinateTop = {x: (halfWidth - e.clientX)/100, y: (halfHeight - e.clientY)/100}
    // })
  },
  methods: {
    titleMove(e) {
      this.moving = true;
      let fullWidth = document.documentElement.clientWidth;
      let fullHeight = document.documentElement.clientHeight;
      let halfWidth = fullWidth / 2; //原屏幕宽的一半（从左至右）
      let halfHeight = fullHeight / 2;
      // console.log({x: (halfWidth - e.clientX)/100, y: (halfHeight - e.clientY)/100})
      this.coordinate = {
        x: (halfWidth - e.clientX) / 100,
        y: (halfHeight - e.clientY) / 100
      };
    },
    resetMove(e) {
      this.moving = false;
      this.coordinate = { x: 0, y: 0 };
    }
  }
};
</script>

<style>
html,
#app {
  height: 100%;
  overflow: hidden !important;
}
body {
  background-color: #f4f4f4;
  margin: 0;
  height: 100%;
}
h1,
h2,
h3,
h4,
h5 {
  font-weight: 300;
  margin: 0;
}
hr {
  display: block;
  unicode-bidi: isolate;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: auto;
  margin-inline-end: auto;
  overflow: hidden;
  border-style: inset;
  border-width: 1px;
  border-color: rgba(0, 0, 0, 0.2);
}
p {
  margin-bottom: 0;
}
a {
  text-decoration: none;
}
.view {
  position: relative;
  margin-left: 58% !important;
  margin-right: 8% !important;
  height: 100vh;
}
.bg-2 {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 42%;
  background-color: #dc9495;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.25);
  user-select: none;
}
.bg-2 .avatar {
  position: absolute;
  transform: translate(36%, -50%);
  top: 50%;
  right: 0;
  background-color: #fbc5c5;
  background-image: url(https://i.loli.net/2019/11/15/Irx7lWPRZgcY41H.jpg);
  background-position: center;
  background-size: cover;
  box-sizing: border-box;
  border: 20px solid #fbc5c5;
  box-shadow: 0 0 10px 0px rgba(255, 0, 0, 0.3);
  height: 42%;
  width: 70%;
}
.bg-2 .font-bottom {
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  left: 18%;
  font-size: 6rem;
  letter-spacing: 16px !important;
  font-weight: 700;
  color: red;
}
.bg-2 .font-top {
  position: absolute;
  transform: translate(0, -50%);
  top: 50%;
  left: 18%;
  font-size: 6rem;
  letter-spacing: 18px !important;
  font-weight: 600;
  color: white;
  z-index: 1;
}
.cube {
  z-index: 100;
  position: absolute;
  right: 8%;
  top: 46px;
  width: 7%;
  height: 1.5rem;
  background-color: #fbc5c5;
  box-shadow: 0 0 10px 0px rgba(255, 0, 0, 0);
  transform: translateY(0);
  transition: all ease-in 0.3s;
}
.cube:hover {
  transform: translateY(-3px);
  background-color: #dc9495;
  box-shadow: 0 5px 10px 0px rgba(255, 0, 0, 0.2);
}
.navbar {
  z-index: 90;
  position: fixed;
  top: 41px;
  left: 8vw;
  right: 62vw;
  padding: 5px 0;
  color: white;
}
.navbar ul {
  position: relative;
  display: flex;
  list-style-type: none;
  margin-block-start: 0;
  margin-block-end: 0;
  margin-inline-start: -1rem;
  margin-inline-end: -1rem;
  padding-inline-start: 0;
  padding-inline-end: 0;
  overflow: auto;
}
.navbar ul li {
  margin-inline-start: 1rem;
  margin-inline-end: 1rem;
  flex: 1;
  text-align: center;
}
.navbar ul li a {
  position: relative;
  font-size: 1.2rem;
  font-weight: 500;
  color: white;
  text-decoration: none;
  transition: all ease 0.3s;
}
.navbar ul li a:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  width: 0;
  transform: translateY(-50%);
  height: 2px;
  background-color: white;
  transition: width 350ms, left 350ms;
}
.navbar ul li a:hover:after {
  left: 0;
  width: 100%;
  transition: width 350ms;
}
.navbar ul li .router-link-exact-active:after {
  left: 0;
  width: 100%;
  transition: width 350ms, left 350ms;
}
.footer {
  z-index: 90;
  position: fixed;
  display: flex;
  padding: 5px 8%;
  bottom: 41px;
  right: 0;
  left: 0;
  color: white;
}
.footer > span {
  position: relative;
  font-size: 1.2rem;
  font-weight: 200;
}
.footer > span:after {
  content: "";
  position: absolute;
  top: -5px;
  bottom: -5px;
  left: -10px;
  right: -10px;
  background-color: #dc9495;
  z-index: -2;
}

/****OTHER */
.row {
  display: flex;
}
.col-1 {
}

@media screen and (max-width: 1530px) {
  .navbar {
    right: 60vw;
  }
  .footer {
    justify-content: flex-end;
  }
}

@media screen and (max-width: 1100px) {
  .cube {
    display: none;
  }
  .view {
    margin-left: 8% !important;
  }
  .view .sv {
    top: 138px;
    left: 0;
    right: 0;
    bottom: 28px;
    padding: 10px 0;
  }
  .bg-2 {
    height: 138px;
    width: 100%;
  }
  .bg-2 .avatar {
    transform: translate(100%, -50%);
    top: 50px;
    right: 92vw;
    border: 3px solid #fbc5c5;
    height: 32px;
    width: 32px;
    border-radius: 50%;
  }
  .bg-2 .font-top,
  .bg-2 .font-bottom {
    font-size: 2rem;
    left: calc(8vw + 42px);
    top: 50px;
  }
  .bg-2 .font-bottom {
    z-index: -3;
  }
  .navbar {
    top: 80px;
    right: 0;
    left: 0;
    padding: 5px 8vw;
    background-color: #dc9495;
  }
  .navbar ul li {
    height: 3rem;
    text-align-last: center;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-inline-start: 1.5rem;
    margin-inline-end: 1.5rem;
  }
  .navbar ul {
    margin-inline-start: -1.5rem;
    margin-inline-end: -1.5rem;
  }
  .home {
    text-align: center;
    justify-content: center;
  }
}

@media screen and (max-width: 525px) {
  .cube {
    display: block;
  }
  .footer {
    justify-content: center;
    padding: 12px;
    bottom: 0;
    background-color: #dc9495;
  }
  .footer > span {
    font-size: 0.6rem;
  }
  .bg-2 .font-top {
    transition: all 0.1s ease-in 0s !important;
  }
  .bg-2 .font-bottom {
    transition: all 0.3s ease-in 0s !important;
  }
}

/**** */
.scroll-y-reverse-transition-enter-active,
.scroll-y-reverse-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}
.scroll-y-reverse-transition-move {
  transition: transform 0.6s;
}
.scroll-y-reverse-transition-enter,
.scroll-y-reverse-transition-leave-to {
  opacity: 0;
}
.scroll-y-reverse-transition-enter {
  transform: translateY(15px);
}
.scroll-y-reverse-transition-leave-to {
  transform: translateY(-15px);
}
</style>
